<template>
    <div class="tools-same-box">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-box">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>同分去向</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row type="flex" justify="space-between" :gutter="16">
            <el-col :span="16">
                <el-row class="tools-box-content">
                    <h5>同分去向</h5>
                    <!-- <div class="zy-text" v-if="gkInfor.score">
                        <div>
                            {{province}} <span></span> {{gkInfor.subject}} <span></span> {{gkInfor.score}}分<span></span> {{gkInfor.batch}}</a>
                        </div>
                        <span class="con-score-span" @click="showGkInforHandler"><img src="../../assets/images/edit.png" /> </span>
                    </div> -->
                    <div class="tools-same-search">
                        <div class="search-img header-search">
                            <el-row class="tools-same-select">
                                <el-col class="tools-same-select-item" :span="7">
                                    <span @mouseenter="hoverMenuHandler1()" @mouseleave="hoverMenuHandler1()">
                                        生源地：
                                        <span v-if="optionsProvince.length > 0" class="tools-same-select-content">
                                            {{optionsProvince[activeIndex1].name}} <i class="el-icon-arrow-down" v-if="!hoverStatus1"></i><i class="el-icon-arrow-up" v-else></i>
                                        </span>
                                        <ul class="menu-tools-ul menu-tools-ul-diff1" v-if="hoverStatus1">
                                            <li @click="changeOptionsHandler1(index,item)" v-for="(item,index) in optionsProvince" :key="index">{{item.name}}</li>
                                        </ul>
                                    </span>
                                </el-col>
                                <el-col v-if="optionsBatch.length > 0" class="tools-same-select-item" :span="7">
                                    <span @mouseenter="hoverMenuHandler2()" @mouseleave="hoverMenuHandler2()">
                                    科目类别：
                                        <span class="tools-same-select-content">
                                            {{optionsBatch[activeIndex2].name}} <i class="el-icon-arrow-down" v-if="!hoverStatus2"></i><i class="el-icon-arrow-up" v-else></i>
                                        </span>
                                        <ul class="menu-tools-ul" v-if="hoverStatus2">
                                            <li @click="changeOptionsHandler2(item, key)" v-for="(item,key) in optionsBatch" :key="key">{{item.name}}</li>
                                        </ul>
                                    </span>
                                </el-col>
                                <el-col class="tools-same-select-item" :span="8">
                                    <span @mouseenter="hoverMenuHandler3()" @mouseleave="hoverMenuHandler3()">
                                    分数/位次筛选：
                                        <span class="tools-same-select-content">
                                            {{optionsType[activeIndex3].label}} <i class="el-icon-arrow-down" v-if="!hoverStatus3"></i><i class="el-icon-arrow-up" v-else></i>
                                        </span>
                                        <ul class="menu-tools-ul menu-tools-ul-diff2" v-if="hoverStatus3">
                                            <li @click="changeOptionsHandler3(index,item)" v-for="(item,index) in optionsType" :key="index">{{item.label}}</li>
                                        </ul>
                                    </span>
                                </el-col>
                            </el-row>
                            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" @submit.native.prevent>
                                <el-form-item label="高考分数/预估分数：" prop="score" v-if="activeIndex3 == 0">
                                    <el-input placeholder="请输入分数" v-model="ruleForm.score" @keyup.enter.native="searchSameHandler()"></el-input>
                                </el-form-item>
                                <el-form-item label="位次：" prop="rank"  v-else>
                                    <el-input placeholder="请输入位次" v-model="ruleForm.rank" @keyup.enter.native="searchSameHandler()"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button @click="searchSameHandler" class="tools-btn">查询</el-button>
                                </el-form-item>
                            </el-form>
                            <div>
                            </div>
                        </div>
                    </div>
                    <div class="province-list">
                        <div class="title-box">年份：</div>
                        <div class="province-name">
                            <a v-for="(item,index) in yearList" :key="index" :class="activeTag == index?'active-tag':''" @click="changeOptionsHandler4(index,item)">{{item}}</a>
                        </div>
                    </div>
                    <el-row class="tools-same-list" v-if="showNoStatus">
                        <h3>查询结果 <span>“-”表示暂无该项数据或学校该年无招生</span></h3>
                            <el-table :data="schoolList" stripe style="width: 100%" border v-if="totalData > 0">
                                <el-table-column prop="scl_name" label="学校" width="440">
                                </el-table-column>
                                <el-table-column prop="spname" label="专业" width="200">
                                </el-table-column>
                                <el-table-column prop="year" label="年份">
                                </el-table-column>
                            </el-table>
                            <el-pagination
                                background
                                layout="prev, pager, next, jumper"
                                :total="totalData" :page-size="10" @current-change="getSpecialHandler" :current-page.sync='currentPage' v-if="totalData > 0">
                            </el-pagination>
                            <div class="no-data-box" v-if="totalData == 0">
                                <img src="../../assets/images/null.png" alt="没有数据">
                                <p>你选择的分类下暂无相关分数线数据，你可以调整搜索条件或尝试不同批次与年份</p>
                            </div>
                    </el-row>
                    
                </el-row>
            </el-col>
            <el-col :span="8" class="tools-box-news">
                <SchoolRank></SchoolRank>
                <News></News>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { getSpecial } from "@/api/tools"
import { getBatch } from "@/api/home"
export default {
    data() {
        const validateScore = (rule, value, callback) => {
            if (value.length === 0) {
            callback(new Error("请输入分数"));
            } else {
                if ((/(^[1-9]\d*$)/.test(value))) {
                    callback();
                } else {
                    callback(new Error("请输入正确的分数"));
                }
            }
        }; 
        const validateRank = (rule, value, callback) => {
            if (value.length === 0) {
            callback(new Error("请输入排名"));
            } else {
                if ((/(^[1-9]\d*$)/.test(value))) {
                    callback();
                } else {
                    callback(new Error("请输入正确的排名"));
                }
            }
        }; 
        return {
            ruleForm: {
                local_type_id: '',
                area: '',
                year: '',
                score: this.$store.state.user.gkInforObj.score,
                rank: '',
                type: '1'
            },
            rules: {
                score: [
                    { trigger: 'blur', validator: validateScore },
                ],
                rank: [
                    { trigger: 'blur', validator: validateRank },
                ],
            },
            showNoStatus: false,
            optionsProvince: [],
            optionsBatch: [],
            optionsType: [
                {
                    label: '按分数',
                    value: '1',
                },
                {
                    label: '按位次',
                    value: '2',
                },
            ],
            yearList: [],
            activeTag: 0,
            totalData: 0,
            currentPage: 1,
            hoverStatus1: false,
            hoverStatus2: false,
            hoverStatus3: false,
            activeIndex1: 0,
            activeIndex2: 0,
            activeIndex3: 0,
            schoolList: []
        };
    },
    mounted() {
        let year = (new Date()).getFullYear();
        for(let i = 0; i < 9; i++) {
            this.yearList.push(year - i);
        }
        this.getAreaHandler();
    },
    methods: {
        searchSameHandler() {
            this.changeCommonTypeHandler();
        },
        getAreaHandler() {
            setTimeout(() => {
                this.optionsProvince = JSON.parse(sessionStorage.getItem('proInfo'))
                this.changePro()
            }, 300);
           
        },
        changePro() {
            const param = {
                area: this.optionsProvince[this.activeIndex1].area,
                year: this.yearList[this.activeTag]
            }
            getBatch(param).then(res => {
                this.optionsBatch = res.data.local_type_id
                this.ruleForm.area = this.optionsProvince[this.activeIndex1].area
                this.ruleForm.local_type_id = this.optionsBatch[this.activeIndex2].local_type
                this.changeCommonTypeHandler();
            })
        },
        getSpecialHandler(page) {
            let that = this;
            this.$refs.ruleForm.validate((valid) => {
                if(valid) {
                    if(this.ruleForm.type == '1') {
                        this.ruleForm.rank = '';
                    } else {
                        this.ruleForm.score = '';
                    }
                    this.ruleForm.year = this.yearList[this.activeTag];
                    getSpecial(this.ruleForm,page).then(res => {
                        this.showNoStatus = true;
                        if(res.data) {
                            this.schoolList = res.data.list.data;
                            this.totalData = res.data.list.total;
                        }
                    })
                }
            })
        },
        hoverMenuHandler1() {
            this.hoverStatus1 = !this.hoverStatus1;
        },
        changeOptionsHandler1(index,item) {
            this.activeIndex1 = index;
            this.ruleForm.area = item.area;
            this.changePro()
        },
        hoverMenuHandler2() {
            this.hoverStatus2 = !this.hoverStatus2;
        },
        changeOptionsHandler2(item, key) {
            this.activeIndex2 = key;
            this.ruleForm.local_type_id = item.local_type;
            this.changeCommonTypeHandler();
        },
        hoverMenuHandler3() {
            this.hoverStatus3 = !this.hoverStatus3;
        },
        changeOptionsHandler3(index,item) {
            this.activeIndex3 = index;
            this.ruleForm.type = item.value;
            this.ruleForm.score = '';
            this.ruleForm.rank = '';
            this.$refs.ruleForm.resetFields();
            
        },
        changeOptionsHandler4(index,item) {
            this.activeTag = index;
            this.ruleForm.year = item;
            this.changePro();
        },
        changeCommonTypeHandler() {
            if(this.ruleForm.score || this.ruleForm.rank) {
                this.totalData = 0;
                this.currentPage = 0;
                this.showNoStatus = false;
                this.getSpecialHandler('1');
            }
        }
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables.scss";
.tools-same-box {
    @include gwidth;
    .tools-box-content {
        padding: 24px;
        background: #ffffff;
        border-radius: 10px;
        box-shadow: 0px 1px 2px 0px rgba(44,46,51,0.10); 
        margin-top: 24px;
        h5 {
            border-left: 2px solid $common-color;
            border-radius: 1px;
            font-size: 22px;
            font-weight: 600;
            color: #2c2e33;
            padding-left: 8px;
            text-align: left;
            padding-bottom: 0px;
            margin-bottom: 24px;
            margin-top: 0;
        }
    }
    .tools-same-search {
        background: url('../../assets/images/tools-search-same.png') no-repeat;
        background-size: contain;
        height: 199px;
        padding: 24px;
        box-sizing: border-box;
        margin-top: 20px;
    }
    .tools-btn {
        width: 136px;
        height: 52px;
        border: none!important;
        background: linear-gradient(90deg,#ffa94a, #ff913c);
        border-radius: 8px;
        font-size: 18px;
        font-weight: 400;
        color: #ffffff;
        border: none;
        margin-left: 14px;
        position: relative;
        top: 40px;
    }
    // .tools-same-select {
    //     margin-bottom: 8px;
    // }
   .tools-same-select-item {
       position: relative;
       span {
            font-size: 18px;
            font-weight: 400;
            color: rgba(255,255,255,0.60);
            line-height: 25px;
            cursor: pointer;
            display: inline-block;
            height: 35px;
       }
       .tools-same-select-content {
            font-size: 18px;
            color: #ffffff;
            margin-left: -5px;
       }
       .el-icon-arrow-down {
           color: rgba(255,255,255,0.6);
       }
   }
}
.province-list {
    @include gflex;
    font-size: 0;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 6px;
    .title-box {
        width: 45px;
        font-size: 14px;
        text-align: left;
        color: #909399;
        margin-top: 3px;
    }
    a {
        display: inline-block;
        font-size: 14px;
        color: #5e6166;
        cursor: pointer;
        text-align: center;
        margin-bottom: 10px;
        padding: 3px 5px;
    }
    a:not(:nth-child(13n)) {
        margin-right: 12px;
    }
    .active-tag {
        color: #ffffff!important;
        background: $common-color;
        border-radius: 4px;
    }
    a:hover {
        color: $common-color;
    }
    .province-name {
        @include gflex;
        width: calc(100% - 4px);
        justify-content: flex-start;
        flex-wrap: wrap;
    }
}
.tools-box-news {
    margin-top: 24px;
}
.no-data-box {
    position: absolute;
    top: 65%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    width: 100%;
    img {
        width: 110px;
        height: 110px;
    }
    p {
        font-size: 16px;
        text-align: center;
        color: #abaeb3;
        margin-left: -14px;
    }
}
.menu-tools-ul {
    position: absolute;
    height: auto;
    padding: 10px 24px 12px 24px;
    background: #ffffff;
    border-radius: 6px;
    box-shadow: 0px 1px 6px 0px rgba(51,55,61,0.20); 
    z-index: 9999;
    color: #5e6166;
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    line-height: 30px;
    box-sizing: border-box;
    left: 75px;
    top: 40px;
    margin-top: -8px;
    background: rgba(255,255,255,0.80);
    border-radius: 10px;
    box-shadow: 0px 4px 8px 0px rgba(0,0,0,0.10); 
    backdrop-filter: blur(6px);
    .menu-li {
        color: #332e2c!important;
        font-size: 18px;
        font-weight: 600;
    }
    li {
        padding: 0;
        list-style: none;
        cursor: pointer;
    }
    li:hover {
        color: $common-color;
    }
}
.menu-tools-ul-diff1 {
    left: 60px;
}
.menu-tools-ul-diff2 {
    left: 120px;
}
.tools-same-list {
    min-height: 280px;
    position: relative;
    h3 {
        font-size: 18px;
        font-weight: 600;
        text-align: left;
        color: #332e2c;
        margin: 8px 0 16px 0;
        line-height: 25px;
        span {
            float: right;
            font-size: 12px;
            font-weight: 400;
            text-align: right;
            color: #909399;
        }
    }
}
</style>